// Every X-ray the host should mount. The ONE file that changes when a lens is
// added, and the reason the surface is bounded: an agent writes its own
// `xrays/<id>.xray.js` plus a line here, and touches nothing the host owns.
import ci from "./ci.xray.js";
import deps from "./deps.xray.js";
import iac from "./iac.xray.js";
import procs from "./procs.xray.js";
import transfer from "./transfer.xray.js";
import live from "./live.xray.js";
import sections from "./sections.xray.js";
import secrets from "./secrets.xray.js";
import sql from "./sql.xray.js";
import projection from "./projection.xray.js";
import wait from "./wait.xray.js";

export const MANIFESTS = [ci, deps, iac, live, procs, projection, secrets, sections, sql, transfer, wait];

// Lenses the host still wires by hand. Listed so a manifest cannot silently
// shadow a working one — migrating a lens means deleting its entry here in the
// same change that adds its manifest, which makes the swap visible in one diff.
export const HOST_WIRED = [
  "terms", "describe", "workflows", "behaviours", "files", "linear", "research",
  "forge", "grafana", "dataq", "recall", "artifacts", "lineage",
];
